import { mobile, tablet } from '../../../utils/breakpoints'
import { Box, styled } from '@mui/material'
import { HEADER_BANNER_HEIGHT, PAGE_WIDTH } from '../../../theme'
import { GridContainer } from '../../Grid/GridContainer'
import { BannerPosition } from '../../../features/Configuration/GeneralConfiguration/types/types'

import { ImageSkeleton } from '../../Skeleton/ImageSkeleton'

export const HeaderBannerContainer = styled(Box)`
  position: relative;
  width: 100%;
`

export const StyledHeaderBanner = styled('img', {
  shouldForwardProp: (prop) => prop !== '$objectPosition',
})<{ $objectPosition: BannerPosition }>`
  display: block;
  width: 100%;
  height: ${HEADER_BANNER_HEIGHT.desktop};
  object-fit: cover;
  object-position: ${({ $objectPosition }) => $objectPosition};
  ${({ theme }) => mobile(theme, { height: HEADER_BANNER_HEIGHT.mobile })}
  ${({ theme }) => tablet(theme, { height: HEADER_BANNER_HEIGHT.tablet })}
`

export const HeaderBannerTextOverlay = styled(GridContainer)`
  position: absolute;
  inset: 0;
  gap: 0;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  pointer-events: none;
  transform: translateY(10%);
  width: ${PAGE_WIDTH.desktop};
  margin: 0 auto;
  ${({ theme }) => tablet(theme, { width: PAGE_WIDTH.tablet })}
  ${({ theme }) => mobile(theme, { width: PAGE_WIDTH.mobile })}
  & > * {
    text-shadow: 0 1px 8px rgb(0 0 0 / 55%);
  }
`

export const BannerSkeleton = styled(ImageSkeleton)`
  width: 100%;
  height: ${HEADER_BANNER_HEIGHT.desktop};
  ${({ theme }) => mobile(theme, { height: HEADER_BANNER_HEIGHT.mobile })}
`
